
<section class="st-cta st-combo">
    <div class="background">
        <div class='canvas'>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>			
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>
			<div class='bubble'></div>			
		</div>
        <img src="../../../assets/img/03.jpg" alt="">
    </div>
    <div class="container">
        <div class="content">
            <h2 class="h-large">{{ 'hp.register.lbl.001' | translate }}</h2>
            <p class="">{{ 'hp.register.lbl.002' | translate }}</p>
			<p class="">{{ 'hp.register.lbl.003' | translate }}</p>
            <a class="w-btn rounded-btn" routerLink="/shopping-mall/category/0111">
                <span>{{ 'hp.register.lbl.004' | translate }}</span>
                <div></div>
            </a>
        </div>        			
    </div>
</section>